import {
  FLIGHT_TYPE_CODE,
  FLIGHT_TYPE_INFO,
  ROUND_TRIP,
  ONE_WAY,
  MULTI_DESTINATION
} from '../constants'

export const HOTEL = 'STAY'
export const FLY = 'FLY'
export const DRIVE = 'DRIVE'

export const CABIN_CLASS = {
  Economy: 'ECO',
  'Premium Economy': 'PEC',
  Business: 'BUS',
  First: 'FST'
} as const

export const CABIN_OPTIONS = [
  { label: 'Economy', value: 'economy' },
  { label: 'Premium Economy', value: 'premium_economy' },
  { label: 'Business', value: 'business' },
  { label: 'First', value: 'first' }
] as const

export const FLIGHT_TYPE_OPTIONS = [
  {
    value: FLIGHT_TYPE_CODE[ROUND_TRIP],
    label: FLIGHT_TYPE_INFO[ROUND_TRIP].typeLabel
  },
  {
    value: FLIGHT_TYPE_CODE[ONE_WAY],
    label: FLIGHT_TYPE_INFO[ONE_WAY].typeLabel
  },
  {
    value: FLIGHT_TYPE_CODE[MULTI_DESTINATION],
    label: FLIGHT_TYPE_INFO[MULTI_DESTINATION].typeLabel
  }
] as const

export const PLACEHOLDERS = {
  ORIGIN: 'Departing from?',
  DESTINATION: 'Going to?',
  PASSENGERS: 'Passengers',
  PASSENGERS_WITH_HOTEL: '1 Passenger, 1 Room',
  CABIN_CLASS: 'Economy',
  SEARCH_BUTTON: 'Search'
} as const

export const LABELS = {
  ADD_HOTEL: 'Add Hotel',
  ADD_CAR: 'Add Car',
  PACKAGE_DEALS: 'Package Deals',
  CABIN_CLASS: 'Cabin class',
  PASSENGERS: 'Passengers',
  PASSENGERS_WITH_HOTEL: 'Passengers with Hotel'
} as const

export const FLIGHT_LIMITS = {
  MAX_FLIGHTS: 5,
  MIN_FLIGHTS: 1
} as const

export const DEFAULT_VALUES = {
  FLIGHT_TYPE: FLIGHT_TYPE_CODE[ROUND_TRIP],
  CABIN_CLASS: 'Economy',
  ADD_HOTEL: false,
  ADD_CAR: false
} as const
